import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { SwipeableDrawer, Box, Dialog, DialogContent } from '@mui/material'
import { showFormModal, hideFormModal } from 'state/ui'
import PrintDialog from 'components/generic/printable/PrintDialog'

const FormModal = ({ modalName, children, onHideModal, maxWidth, height, modalType }) => {
  const navigate = useNavigate()
  const { formModalName } = useSelector(state => state.ui)
  const { formTitle, navigateTo } = useSelector(state => state.ui.formModalProps)

  const dispatch = useDispatch()

  const toggle = open => () => {
    if (open) {
      dispatch(showFormModal(modalName))
    } else if (onHideModal) {
      onHideModal()
      if (navigateTo) {
        navigate(navigateTo)
      }
    } else {
      dispatch(hideFormModal())
    }
  }

  const renderModal = type => {
    switch (type) {
      case 'drawer':
        return (
          <SwipeableDrawer
            anchor="right"
            open={formModalName.includes(modalName)}
            onClose={toggle(false)}
            onOpen={toggle(true)}
            PaperProps={{ sx: { maxWidth: { maxWidth }, width: '100%' } }}
            disableSwipeToOpen
          >
            <Box role="presentation">{children}</Box>
          </SwipeableDrawer>
        )
      case 'center':
        return (
          <Dialog
            sx={{
              '& .MuiDialog-paper': {
                width: '100%',
                maxWidth: maxWidth || 1200,
                height,
              },
            }}
            aria-labelledby="customized-dialog-title"
            open={formModalName.includes(modalName)}
            onClose={toggle(false)}
          >
            <DialogContent dividers sx={{ padding: 2 }}>
              {children}
            </DialogContent>
          </Dialog>
        )
      case 'print':
        return (
          <PrintDialog
            dialogId="print-dialog"
            title={formTitle}
            open={formModalName.includes(modalName)}
            onClose={toggle(false)}
            layoutWidth="100%"
            showLogoAddress
          >
            {children}
          </PrintDialog>
        )
      default:
        return null
    }
  }

  return renderModal(modalType)
}

FormModal.propTypes = {
  modalName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onHideModal: PropTypes.func,
  maxWidth: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalType: PropTypes.oneOf(['drawer', 'center', 'print']),
}

FormModal.defaultProps = {
  onHideModal: null,
  maxWidth: 1024,
  height: 800,
  modalType: 'drawer',
}

export default FormModal
